<template>
  <div class="ace-smart-milling">
    <h2 class="ace-smart-milling__title">Net Zero Smart Milling</h2>
    <div class="ace-smart-milling__container">
      <div class="row">
        <div class="col-md-6 ace-smart-milling__copy">
          <h3 class="ace-smart-milling__subtitle">Smart milling for net zero carbon</h3>
          <p>
            Make Net Zero Carbon Feed Milling a reality with our SmartMilling intelligent moisture
            application solutions. Our studies show that the national average addition of 2% can offset all of the
            emissions associated with your feed mill operations. The iBox's precision
            measurement and application enables you to safely optimise moisture content to improve
            yield and reduce your carbon.
          </p>
        </div>
        <div class="col-md-6 ace-smart-milling__image">
          <img
              srcset="./images/ibox.png, ./images/ibox@2x.png 2x"
              src="./images/ibox.png"
              alt="ibox"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/mixins';

.ace-smart-milling {
  &__container {
    text-align: left;

    background: #f1f1f2;

    margin-top: 20px;
    padding: 30px 15px;

    position: relative;

    &:before {
      background: #707070;

      width: 1px;

      display: block;

      bottom: 30px;
      left: 50%;
      position: absolute;
      top: 30px;
      @media screen and (min-width: 767px) {
        content: '';
      }
    }
  }

  &__copy {
    padding: 0 30px;

    h3 {
      @include title;

      margin: 0;
    }

    p {
      font-size: 20px;
      font-weight: 300;
    }
  }

  &__image {
    border-top: 2px solid #ffffff;

    margin-top: 30px;
    padding: 30px 30px 0;

    display: flex;

    align-items: center;
    justify-content: center;
    @media screen and (min-width: 767px) {
      border-top: none;

      margin-top: 0;
      padding-top: 0;
    }
  }
}
</style>
